import { IDefineCommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import { UpdateSectionSelectedFlagCommand } from '../../unscheduled_sections/commands/update_section_selected_flag_command';
import { GetPusherSeatsAvailableCommand } from './get_pusher_seats_available_command';

export type UpdateSeatAvailabilityCommand = (sectionIds?: Array<ISection['id']>) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'updateSeatAvailabilityCommand',
    (
      defineCommandORM: IDefineCommand,
      getPusherSeatsAvailableCommand: GetPusherSeatsAvailableCommand,
      $q: ng.IQService,
      updateSectionSelectedFlagCommand: UpdateSectionSelectedFlagCommand
    ) => {
      return defineCommandORM('updateSeatAvailabilityCommand', (deferred, sectionIds?: Array<ISection['id']>) => {
        return getPusherSeatsAvailableCommand(sectionIds)
          .then(() => {
            if (sectionIds) {
              $q.all(sectionIds.map((sectionId) => updateSectionSelectedFlagCommand(sectionId))).then(deferred.resolve);
            }
            deferred.resolve();
          })
          .catch(deferred.reject);
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/commands/update_seat_availability_command.ts